/**
 * Shared tooltip wrapper for disabled Create RMA submit actions (payment block, out-of-policy, etc.).
 */
import { ReactNode } from 'react';
import FontBody2 from '../../../components/fonts/font-body2/font-body2';
import { FONT_COLOR } from '../../../components/fonts/font-props';
import { Tooltip, TOOLTIP_VARIANTS } from '../../../components/tooltip/tooltip';
import { TOOLTIP_PLACEMENTS } from '../../../components/tooltip/tooltip-box';
import {
    CREATE_RMA_SUBMIT_BLOCK_REASONS,
    getCreateRmaSubmitBlockTranslationKeys,
} from '../../manage-returns/rma-page/rma-types';

interface ICreateRmaSubmitBlockTooltipWrapperProps {
    children: ReactNode ;
    blockReason?: CREATE_RMA_SUBMIT_BLOCK_REASONS;
    getTranslation: (key: string, scope: string) => string;
    tooltipPlacement?: TOOLTIP_PLACEMENTS;
}

export const CreateRmaSubmitBlockTooltipWrapper = ({
    children,
    blockReason,
    getTranslation,
    tooltipPlacement = TOOLTIP_PLACEMENTS.LEFT,
}: ICreateRmaSubmitBlockTooltipWrapperProps): ReactNode => {
    if (!blockReason) {
        return children;
    }

    const translationKeys = getCreateRmaSubmitBlockTranslationKeys(blockReason);
    const tooltipKey = translationKeys?.tooltipKey;
    if (!tooltipKey?.key || !tooltipKey.scope) {
        return children;
    }

    return (
        <Tooltip
            placement={tooltipPlacement}
            variant={TOOLTIP_VARIANTS.TEXT}
            content={
                <FontBody2 color={FONT_COLOR.NEUTRAL_1_WHITE}>
                    {getTranslation(tooltipKey.key, tooltipKey.scope)}
                </FontBody2>
            }
        >
            {children}
        </Tooltip>
    );
};
